<h2 mat-dialog-title>Envoi et réception eHealthBox</h2>
<mat-dialog-content>
<div class="panel panel-default ">
	  <div [ngClass]="" class="panel-body">
      <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="tabChanged($event)">
        <mat-tab label="Réception">
            <mat-table #table [dataSource]="ehealth.messagelist" class="ehealth-messagelist">
              <ng-container matColumnDef="sender">
                <mat-header-cell *matHeaderCellDef> Source </mat-header-cell>
                <mat-cell *matCellDef="let message"> {{message.sender?.lastName}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef> Titre </mat-header-cell>
                <mat-cell *matCellDef="let message"> {{getMessageTitle(message)}} </mat-cell>
              </ng-container>
              <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                <mat-cell *matCellDef="let message"> {{message.publicationDateTime}} </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectMessage(row.id)"></mat-row>
            </mat-table>
        </mat-tab>
        <mat-tab label="Envoi">
          <mat-tab-group [selectedIndex]="selectedSendTab" (selectedIndexChange)="sendTabChanged($event)">
            <mat-tab label="Messages">
              <mat-table #table [dataSource]="ehealth.messagesendlist" class="ehealth-messagesendlist">
                <ng-container matColumnDef="document">
                  <mat-header-cell *matHeaderCellDef> Document </mat-header-cell>
                  <mat-cell *matCellDef="let message"> {{getSendMessageType(message)}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="recipient">
                  <mat-header-cell *matHeaderCellDef> Destinataire </mat-header-cell>
                  <mat-cell *matCellDef="let message"> {{message.properties.DestinataireDescription}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="patient">
                  <mat-header-cell *matHeaderCellDef> Patient </mat-header-cell>
                  <mat-cell *matCellDef="let message"> {{message.properties.PatientDescription}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="date">
                  <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                  <mat-cell *matCellDef="let message"> {{message.properties.RapportDate}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="msg">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let message"><i [hidden]="getSendMessageError(message) === null" [matTooltip]="getSendMessageError(message)" class="fa fa-2x fa-exclamation-triangle"></i></mat-cell>
                </ng-container>
                <ng-container matColumnDef="delete">
                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                  <mat-cell *matCellDef="let message"><i (click)="removeMessageFromQueue(message)" class="far fa-2x fa-trash-alt fakelink"></i></mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedSendColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedSendColumns;" (click)="selectSendMessage(row.id)"></mat-row>
              </mat-table>  
            </mat-tab>
            <mat-tab label="Message Texte">
              <div class="sendcontainer">
                <mat-form-field class="inputfullwidth">
                  <input type="text" placeholder="Destinataire" aria-label="Destinataire" matInput [formControl]="destinataireControl" [matAutocomplete]="autoDestinataire">
                  <mat-autocomplete #autoDestinataire="matAutocomplete" [displayWith]="displayDestinataire">
                    <mat-option *ngFor="let destination of destProposition" [value]="destination">
                      {{destination.name}} {{destination.nihii}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-grid-list cols="2" rowHeight="70px">
                  <mat-grid-tile>
                    <mat-form-field class="inputfullwidth">
                      <input type="text" placeholder="Patient" aria-label="Patient" matInput [formControl]="patientControl" [matAutocomplete]="autoPatient" [disabled]="patient.searchingpatient">
                      <mat-icon *ngIf="patient.searchingpatient" class="fa fa-sync-alt fa-spin fa-fw" matSuffix></mat-icon>
                      <mat-autocomplete #autoPatient="matAutocomplete" [displayWith]="displayPatient">
                        <mat-option *ngFor="let patient of patientProposition" [value]="patient">
                          {{patient.firstname}} {{patient.lastname}} {{patient.birthdate}} {{patient.sex}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>                    
                  </mat-grid-tile>
                  <mat-grid-tile>
                    <mat-checkbox class="example-margin" [(ngModel)]="userConfig.userSearchOptions.searchreferring">Mes patients</mat-checkbox>
                  </mat-grid-tile>
                </mat-grid-list>
                <mat-form-field class="inputfullwidth">
                  <textarea matInput placeholder="Entrez votre message" [(ngModel)]="sendmessage"></textarea>
                </mat-form-field>
              </div>        
            </mat-tab>
          </mat-tab-group>

      </mat-tab>
    </mat-tab-group>
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close class="btn btn-danger">Fermer</button>
    <button mat-button mat-dialog-close class="btn btn-success" (click)="okButtonClicked()">{{okButtonLabel}}</button>
</mat-dialog-actions>
